<script setup>
import { reactive, watch } from 'vue';

import { billedAppointmentsForGivenDay } from '../firebase_files/appointment_functions';
import { convertToStringWithCommas } from '@/libraries/HelperFunctions';
import router from '@/router';
import { store, toggleCorrectNavigationOption } from '@/store';

import { dateString } from '@/libraries/HelperFunctions';

const state = reactive({
  appointments: null,
  patient: null, // for patient editing
})

store.selectedDate = store.selectedDate || dateString(new Date);

toggleCorrectNavigationOption();
fetchAppointments();

async function fetchAppointments() {
  //take all appointments, add names
  state.appointments = null; // makes the spinner come back on reload
  let todaysAppointments = await billedAppointmentsForGivenDay(store.selectedDate);
  state.appointments = await formatAppointmentsForDisplay(todaysAppointments);
}

function newAppointment() {
  //   showPatientSelect.value = true;
  router.push({ name: 'appointment' });
}

function convertAptTypeForDisplay(appointmentType) {
  // Making first letter uppercase
  let aptType = appointmentType.charAt(0).toUpperCase() + appointmentType.slice(1)

  // Returns Out-Patient instead of Regular, and In-Patient instead of inpatient.
  switch (aptType) {
    case "Regular":
      return "Out-Patient";
    case "Inpatient":
      return "In-Patient";
    default:
      return aptType
  }
}

/**
 * Opens an appointment with the uniqueID
 * @param uniqueId 
 */
function openAppointment(uniqueId) {
  router.push({ name: 'appointment', params: { id: uniqueId } }) // shortcut for uniqueId: uniqueId
}

/**
 * Formats the appointments for display by pulling the patient name from Firebase and converting the codes from array to string form
 * @param appointments array of appointments
 */
async function formatAppointmentsForDisplay(appointments) {
  let appointmentsWithNames = [];
  for (let i = 0; i < appointments.length; i++) { // traditional for loop used because await in forEach is no bueno
    if (!appointments[i].codes) { // if no codes it is patient registration
      continue;
    }
    appointments[i].codes = convertToStringWithCommas(appointments[i].codes)
    appointmentsWithNames.push(appointments[i]);
  }
  return appointmentsWithNames;
}


function calculateTotalProfit(appointments) {
  if (!appointments) return 0;
  let total = appointments.reduce((total, apt) => total + apt.price, 0);
  return +total.toFixed(2);
}

/**
 * This is very lazy, but it works for now. To
 * automatically update appointments, watch store. 
 * Call the fetch appointments function whenever this happens.
 */
watch(store, async (newDate, oldDate) => {
  fetchAppointments();
})


</script>
<template>
  <div class="page-title">
    <div>
      <span class="title">Appointments for </span>
      &nbsp;<input type="date" v-model="store.selectedDate">&nbsp;
      <!-- <button @click="fetchAppointments()" title="Reload"><i class="fa fa-rotate"></i></button> -->
    </div>
    <div class="earnings">
      <p>
        Projected Earnings: ${{ calculateTotalProfit(state.appointments) }}
      </p>
      <p></p>
    </div>
    <div>
      <button class="primary" @click="newAppointment()">New Appointment</button>
    </div>
    <div>

    </div>
  </div>

  <div v-if="state.appointments" class="content-box">
    <div class="table-header">
      <div class="date">Date</div>
      <div class="cr">ID #</div>
      <div class="name">Name</div>
      <div class="codes">Billed Codes</div>
      <div class="profit">Estimated Profit</div>
      <div class="type">Visit Type</div>
    </div>
    <div @click="openAppointment(apt.uniqueAppointmentId)" class="appointment-entry" v-for="(apt) in state.appointments"
      :key="apt">
      <div class="date">{{ apt.date }}</div>
      <div class="cr">{{ apt.cr }}</div>
      <div class="name">{{ apt.patientName }}</div>
      <div class="codes">{{ apt.codes }}</div>
      <div class="profit">${{(apt.price).toFixed(2) }}</div>
      <div class="type">{{ convertAptTypeForDisplay(apt.aptType) }}</div>
    </div>
  </div>

  <div v-else>
    <div class="spinner">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>
</template>
<style scoped lang="scss">

.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  div {
    display: flex;
    align-items: center;

    input[type="date"] {
      cursor: pointer;
      margin-right: 10px;
    }

    button {
      margin-left: 10px;
    }
  }
.earnings {
    display: flex;
    justify-content: center;
    align-items: center;
    // background-color: #dff0d8;
    padding: 10px;
    width: auto;
    margin: 0 20px;
    // border-radius: 5px;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    p {
      display: inline;
      font-size: 1.2em;
      font-weight: bold;
      // color: #28a745;
      margin: 0;
    }
  }
}

.appointment-entry {
  border-bottom: 1px solid #ccc;
  display: flex;
  padding: 15px 0;

  &:hover {
    background-color: #ebe7f1;
    cursor: pointer;
  }
}

.table-header {
  display: flex;
  text-transform: uppercase;
  color: #aaa;
  padding: 15px 0;
  border-bottom: solid 2px #aaa;
  font-size: 85%;
}

.appointment-entry,
.table-header {

  .date,
  .cr,
  .name,
  .codes,
  .profit,
  .type {
    flex: 1;
    text-align: center;
    padding: 0 5px;
  }
}

.spinner {
  font-size: 30px;
  text-align: center;
  color: #aaa;
  padding-top: 20px;
}</style>
